// @flow

import type { Dispatch } from 'redux';
import { replace } from 'connected-react-router';
import { getUrlEncodedAssortmentParams } from '../../selectors/filters';
import { getSearch } from '../../../router';

const reflectFiltersInUrl = () => (
  dispatch: Dispatch<any>,
  getState: Function,
) => {
  const state = getState();
  const query = getUrlEncodedAssortmentParams(getState());

  // if we're on this url already we don't have to apply it
  if (getSearch(state) === query) {
    return;
  }

  dispatch(
    replace({
      state: {
        preventReload: true,
        preventScrollTop: true,
      },
      search: query ? `?${query}` : '',
    }),
  );
};

export default reflectFiltersInUrl;
